// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deleteIcon[data-v-556bdf88]{font-size:18px;position:absolute;left:15px;top:15px;cursor:pointer;z-index:1}[data-v-556bdf88] .el-dialog__header{border-bottom:1px solid #ebebeb;padding-bottom:15px}[data-v-556bdf88] .el-drawer__header{border-bottom:1px solid #ebebeb;padding:10px 20px;margin-bottom:0}.buildDetail[data-v-556bdf88] .el-dialog__body,[data-v-556bdf88] .el-dialog__body,[data-v-556bdf88] .el-drawer__body{padding:0}", ""]);
// Exports
module.exports = exports;
